module.exports = __webpack_public_path__ + "img/search.2056b22f.svg";